@if (isBootstrapLoading()) {
  <liv-app-loading-shell />
} @else {
  <router-outlet />
}
